import { isValidElement, ReactElement, ReactNode } from "react";
import slugify from "slugify";

const getTextFromReactNode = (node: ReactNode): string | undefined => {
  if (node === null || node === undefined || typeof node === "boolean") {
    return undefined;
  }

  if (typeof node === "string" || typeof node === "number") {
    return String(node);
  }

  if (Array.isArray(node)) {
    return node.map(getTextFromReactNode).join("");
  }

  if (isValidElement(node)) {
    const element = node as ReactElement<{ children?: ReactNode }>;
    return getTextFromReactNode(element.props.children);
  }

  console.warn("Could not extract text from node", node);
};

const toHtmlId = (node: ReactNode): string | undefined => {
  const text = getTextFromReactNode(node);

  if (!text) {
    return undefined;
  }

  return slugify(text, {
    lower: true,
    strict: true,
    trim: true,
  }).replace(/^[^a-z]+/, "id-");
};

export default toHtmlId;
